var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80 160.003C124.186 160.003 160 124.186 160 80.003C160 35.817 124.186 0 80 0C35.814 0 0 35.817 0 80.003C0 124.186 35.814 160.003 80 160.003Z",
  fill: "#F6F0DA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M89.035 33.2625C89.035 34.1265 88.335 34.8265 87.471 34.8265H73.343C72.38 34.8265 71.6 34.0465 71.6 33.0835V31.1035H45.383V128.9H115.252V31.1035H89.035V33.2625Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M116.841 26.0029H44.447C42.326 26.0029 40.607 27.7219 40.607 29.8429V130.163C40.607 132.284 42.326 134.003 44.447 134.003H116.841C118.962 134.003 120.681 132.284 120.681 130.163V29.8429C120.681 27.7219 118.962 26.0029 116.841 26.0029ZM115.578 128.9H45.709V31.1049H71.926V33.0849C71.926 34.0479 72.706 34.8279 73.669 34.8279H87.797C88.661 34.8279 89.361 34.1279 89.361 33.2639V31.1049H115.578V128.9V128.9Z",
  fill: "#260047"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M66.265 39.9105L66.761 41.0535H65.77L66.265 39.9105ZM66.048 39.2285L64.7 42.3145H65.226L65.574 41.5055H66.956L67.308 42.3145H67.838L66.49 39.2275H66.048V39.2285Z",
  fill: "#260047"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M69.858 42.3146H69.38V42.0886C69.237 42.2716 68.998 42.3576 68.78 42.3576C68.267 42.3576 67.937 42.0016 67.937 41.4406V40.1406H68.415V41.3626C68.415 41.7056 68.585 41.9236 68.884 41.9236C69.106 41.9236 69.288 41.7846 69.38 41.5806V40.1416H69.858V42.3146V42.3146Z",
  fill: "#260047"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M73.873 40.1421H74.351V40.4331C74.434 40.2681 74.655 40.1201 74.899 40.1201C74.99 40.1201 75.069 40.1331 75.121 40.1461L75.052 40.6111C75.008 40.5941 74.939 40.5851 74.865 40.5851C74.674 40.5851 74.448 40.6941 74.352 40.9201V42.3161H73.874V40.1421H73.873Z",
  fill: "#260047"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M76.223 42.3586C75.58 42.3586 75.141 41.8416 75.141 41.2286C75.141 40.6156 75.58 40.0986 76.223 40.0986C76.48 40.0986 76.706 40.1856 76.858 40.3416V40.1416H77.336V42.3156H76.858V42.1116C76.706 42.2716 76.48 42.3586 76.223 42.3586ZM76.28 41.9236C76.558 41.9236 76.745 41.7936 76.858 41.6196V40.8326C76.745 40.6626 76.558 40.5326 76.28 40.5326C75.898 40.5326 75.632 40.8456 75.632 41.2286C75.632 41.6106 75.897 41.9236 76.28 41.9236Z",
  fill: "#260047"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M77.769 39.3176L78.247 38.8516V42.3146H77.769V39.3176Z",
  fill: "#260047"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M78.918 39.8158C78.744 39.8158 78.601 39.6728 78.601 39.4938C78.601 39.3198 78.744 39.1768 78.918 39.1768C79.096 39.1768 79.24 39.3198 79.24 39.4938C79.24 39.6718 79.097 39.8158 78.918 39.8158ZM78.679 40.1418H79.157V42.3158H78.679V40.1418Z",
  fill: "#260047"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M80.591 42.3586C79.948 42.3586 79.508 41.8416 79.508 41.2286C79.508 40.6156 79.947 40.0986 80.591 40.0986C80.848 40.0986 81.074 40.1856 81.226 40.3416V40.1416H81.704V42.3156H81.226V42.1116C81.074 42.2716 80.848 42.3586 80.591 42.3586ZM80.648 41.9236C80.926 41.9236 81.113 41.7936 81.226 41.6196V40.8326C81.113 40.6626 80.926 40.5326 80.648 40.5326C80.265 40.5326 80 40.8456 80 41.2286C80 41.6106 80.265 41.9236 80.648 41.9236Z",
  fill: "#260047"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M82.137 40.1417H82.615V40.3717C82.763 40.1887 82.997 40.0977 83.254 40.0977C83.776 40.0977 84.106 40.4537 84.106 41.0147V42.3147H83.628V41.0927C83.628 40.7497 83.454 40.5317 83.15 40.5317C82.893 40.5317 82.707 40.6747 82.615 40.8747V42.3137H82.137V40.1417V40.1417Z",
  fill: "#260047"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M84.958 41.4938C85.119 41.7418 85.375 41.8898 85.675 41.8898C85.966 41.8898 86.175 41.7378 86.175 41.5068C86.175 41.2898 86.032 41.1458 85.736 41.0378L85.397 40.9158C84.91 40.7378 84.671 40.4678 84.671 40.0468C84.671 39.5078 85.097 39.1768 85.671 39.1768C86.053 39.1768 86.38 39.3288 86.606 39.5988L86.254 39.9418C86.102 39.7598 85.911 39.6548 85.672 39.6548C85.411 39.6548 85.185 39.7898 85.185 40.0108C85.185 40.2368 85.333 40.3368 85.654 40.4538L85.967 40.5708C86.419 40.7408 86.693 41.0138 86.693 41.4748C86.689 42.0138 86.267 42.3658 85.663 42.3658C85.163 42.3658 84.746 42.1398 84.559 41.8088L84.958 41.4938Z",
  fill: "#260047"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M88.915 42.3146H88.437V42.0886C88.294 42.2716 88.055 42.3576 87.837 42.3576C87.324 42.3576 86.994 42.0016 86.994 41.4406V40.1406H87.472V41.3626C87.472 41.7056 87.642 41.9236 87.942 41.9236C88.164 41.9236 88.346 41.7846 88.438 41.5806V40.1416H88.916V42.3146H88.915Z",
  fill: "#260047"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M89.317 40.1416H89.795V40.3416C89.947 40.1846 90.173 40.0986 90.43 40.0986C91.078 40.0986 91.517 40.6156 91.517 41.2286C91.517 41.8416 91.078 42.3586 90.43 42.3586C90.173 42.3586 89.947 42.2716 89.795 42.1106V43.2716H89.317V40.1416ZM90.378 41.9236C90.762 41.9236 91.028 41.6076 91.026 41.2226C91.023 40.7866 90.617 40.4526 90.193 40.5526C90.011 40.5956 89.882 40.7026 89.796 40.8316V41.6186C89.909 41.7936 90.095 41.9236 90.378 41.9236Z",
  fill: "#260047"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M94.242 40.1421H94.72V40.4331C94.803 40.2681 95.024 40.1201 95.268 40.1201C95.359 40.1201 95.438 40.1331 95.49 40.1461L95.42 40.6111C95.377 40.5941 95.307 40.5851 95.233 40.5851C95.042 40.5851 94.816 40.6941 94.72 40.9201V42.3161H94.242V40.1421Z",
  fill: "#260047"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M71.172 41.0236L70.95 40.9586C70.737 40.8976 70.689 40.8066 70.689 40.7016C70.689 40.5716 70.837 40.4976 70.98 40.4976C71.158 40.4976 71.297 40.5846 71.393 40.7196L71.695 40.4256C71.54 40.2136 71.295 40.0986 70.989 40.0986C70.554 40.0986 70.215 40.3336 70.211 40.7206C70.207 41.0426 70.402 41.2816 70.781 41.3856L70.972 41.4376C71.233 41.5156 71.307 41.5896 71.307 41.7156C71.307 41.8676 71.164 41.9456 70.994 41.9456C70.772 41.9456 70.559 41.8366 70.472 41.6456L70.153 41.9566C70.32 42.2256 70.632 42.3586 70.993 42.3586C71.441 42.3586 71.78 42.1016 71.78 41.6846C71.78 41.3286 71.554 41.1366 71.172 41.0236Z",
  fill: "#260047"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M73.474 41.8743C73.38 41.9133 73.3 41.9293 73.165 41.9293C72.961 41.9293 72.826 41.8293 72.826 41.5593V40.5683H73.474V40.1423H72.826V39.3193H72.348V40.1423H71.922V40.5683H72.348V41.6383C72.348 42.1293 72.683 42.3603 73.104 42.3603C73.245 42.3603 73.373 42.3353 73.474 42.3053V41.8743V41.8743Z",
  fill: "#260047"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M93.439 41.6646C93.32 41.8186 93.131 41.9236 92.866 41.9236C92.505 41.9236 92.218 41.6886 92.197 41.3326H93.906C93.91 41.2636 93.91 41.2236 93.91 41.1766C93.91 40.4766 93.432 40.0986 92.862 40.0986C92.194 40.0986 91.717 40.6006 91.727 41.2506C91.738 41.9126 92.314 42.4046 92.975 42.3546C93.34 42.3276 93.622 42.1676 93.804 41.9246L93.439 41.6646ZM92.844 40.5016C93.122 40.5016 93.374 40.6716 93.427 40.9846H92.218C92.283 40.6626 92.566 40.5016 92.844 40.5016Z",
  fill: "#260047"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M82.217 37.6575C82.117 37.6665 82.108 37.8075 82.205 37.8305L84.38 38.3325C84.55 37.9255 84.555 37.5655 84.263 37.4785L82.217 37.6575Z",
  fill: "url(#paint0_linear_411_287)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M86.178 37.3109C86.26 37.3039 86.306 37.4039 86.247 37.4609L83.909 39.7419C83.839 39.8099 83.727 39.7309 83.768 39.6419L84.379 38.3319C84.549 37.9249 84.554 37.5659 84.262 37.4779L86.178 37.3109Z",
  fill: "url(#paint1_linear_411_287)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M88.003 121.459H72.973C72.002 121.459 71.207 120.664 71.207 119.693C71.207 118.722 72.002 117.927 72.973 117.927H88.003C88.974 117.927 89.769 118.722 89.769 119.693C89.768 120.665 88.974 121.459 88.003 121.459Z",
  fill: "#ED4300"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M100 51.2031H60V91.2031H100V51.2031Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_411_287)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80 91.2041C91.046 91.2041 100 82.2501 100 71.2041C100 60.1581 91.046 51.2031 80 51.2031C68.954 51.2031 60 60.1571 60 71.2041C60 82.2491 68.954 91.2041 80 91.2041Z",
  fill: "#FBD9CC"
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M100 51.2031H60V91.2031H100V51.2031Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_411_287)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M76.121 70.8963H73.926V66.0653C73.926 62.6913 76.672 59.9463 80.045 59.9463C83.419 59.9463 86.164 62.6923 86.164 66.0653V70.6863H83.97V66.0653C83.97 63.9013 82.21 62.1403 80.045 62.1403C77.881 62.1403 76.12 63.9013 76.12 66.0653V70.8963H76.121Z",
  fill: "#260047"
}));

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M100 51.2031H60V91.2031H100V51.2031Z",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_411_287)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M87.632 78.5663C87.632 79.5393 86.837 80.3363 85.862 80.3363H74.138C73.165 80.3363 72.369 79.5393 72.369 78.5663V70.1333C72.369 69.1603 73.165 68.3643 74.138 68.3643H85.862C86.837 68.3643 87.632 69.1603 87.632 70.1333V78.5663Z",
  fill: "#ED4300"
}));

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M100 51.2031H60V91.2031H100V51.2031Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_411_287)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M79.189 76.3275V72.3725C79.189 71.9235 79.553 71.5615 80 71.5615C80.448 71.5615 80.811 71.9245 80.811 72.3725V76.3275C80.811 76.7755 80.448 77.1385 80 77.1385C79.553 77.1395 79.189 76.7755 79.189 76.3275Z",
  fill: "white"
}));

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M60.9204 106.273C60.8304 106.903 61.2504 107.383 61.8504 107.383C62.4504 107.383 62.8704 106.873 62.7804 106.243L62.4804 103.573L64.7304 105.223C65.0004 105.403 65.2104 105.523 65.4504 105.523C65.9904 105.523 66.4704 105.073 66.4704 104.533C66.4704 104.053 66.1404 103.723 65.7804 103.573L63.1404 102.433L65.7804 101.263C66.1404 101.113 66.4704 100.813 66.4704 100.333C66.4704 99.7934 66.0204 99.3434 65.4804 99.3434C65.2104 99.3434 65.0004 99.4334 64.7304 99.6434L62.4804 101.293L62.7804 98.5934C62.8704 97.9634 62.4504 97.4834 61.8504 97.4834C61.2504 97.4834 60.8304 97.9934 60.9204 98.6234L61.2204 101.293L58.9704 99.6434C58.7004 99.4334 58.5204 99.3434 58.2504 99.3434C57.7104 99.3434 57.2304 99.7934 57.2304 100.333C57.2304 100.783 57.5604 101.113 57.9204 101.263L60.5604 102.433L57.9204 103.573C57.5904 103.723 57.2304 104.053 57.2304 104.503C57.2304 105.043 57.6804 105.523 58.2204 105.523C58.4904 105.523 58.7004 105.403 58.9704 105.223L61.2204 103.573L60.9204 106.273ZM73.811 106.273C73.721 106.903 74.141 107.383 74.741 107.383C75.341 107.383 75.761 106.873 75.671 106.243L75.371 103.573L77.621 105.223C77.891 105.403 78.101 105.523 78.341 105.523C78.881 105.523 79.361 105.073 79.361 104.533C79.361 104.053 79.031 103.723 78.671 103.573L76.031 102.433L78.671 101.263C79.031 101.113 79.361 100.813 79.361 100.333C79.361 99.7934 78.911 99.3434 78.371 99.3434C78.101 99.3434 77.891 99.4334 77.621 99.6434L75.371 101.293L75.671 98.5934C75.761 97.9634 75.341 97.4834 74.741 97.4834C74.141 97.4834 73.721 97.9934 73.811 98.6234L74.111 101.293L71.861 99.6434C71.591 99.4334 71.411 99.3434 71.141 99.3434C70.601 99.3434 70.121 99.7934 70.121 100.333C70.121 100.783 70.451 101.113 70.811 101.263L73.451 102.433L70.811 103.573C70.481 103.723 70.121 104.053 70.121 104.503C70.121 105.043 70.571 105.523 71.111 105.523C71.381 105.523 71.591 105.403 71.861 105.223L74.111 103.573L73.811 106.273ZM86.7016 106.273C86.6116 106.903 87.0316 107.383 87.6316 107.383C88.2316 107.383 88.6516 106.873 88.5616 106.243L88.2616 103.573L90.5116 105.223C90.7816 105.403 90.9916 105.523 91.2316 105.523C91.7716 105.523 92.2516 105.073 92.2516 104.533C92.2516 104.053 91.9216 103.723 91.5616 103.573L88.9216 102.433L91.5616 101.263C91.9216 101.113 92.2516 100.813 92.2516 100.333C92.2516 99.7934 91.8016 99.3434 91.2616 99.3434C90.9916 99.3434 90.7816 99.4334 90.5116 99.6434L88.2616 101.293L88.5616 98.5934C88.6516 97.9634 88.2316 97.4834 87.6316 97.4834C87.0316 97.4834 86.6116 97.9934 86.7016 98.6234L87.0016 101.293L84.7516 99.6434C84.4816 99.4334 84.3016 99.3434 84.0316 99.3434C83.4916 99.3434 83.0116 99.7934 83.0116 100.333C83.0116 100.783 83.3416 101.113 83.7016 101.263L86.3416 102.433L83.7016 103.573C83.3716 103.723 83.0116 104.053 83.0116 104.503C83.0116 105.043 83.4616 105.523 84.0016 105.523C84.2716 105.523 84.4816 105.403 84.7516 105.223L87.0016 103.573L86.7016 106.273ZM99.5923 106.273C99.5023 106.903 99.9223 107.383 100.522 107.383C101.122 107.383 101.542 106.873 101.452 106.243L101.152 103.573L103.402 105.223C103.672 105.403 103.882 105.523 104.122 105.523C104.662 105.523 105.142 105.073 105.142 104.533C105.142 104.053 104.812 103.723 104.452 103.573L101.812 102.433L104.452 101.263C104.812 101.113 105.142 100.813 105.142 100.333C105.142 99.7934 104.692 99.3434 104.152 99.3434C103.882 99.3434 103.672 99.4334 103.402 99.6434L101.152 101.293L101.452 98.5934C101.542 97.9634 101.122 97.4834 100.522 97.4834C99.9223 97.4834 99.5023 97.9934 99.5923 98.6234L99.8923 101.293L97.6423 99.6434C97.3723 99.4334 97.1923 99.3434 96.9223 99.3434C96.3823 99.3434 95.9023 99.7934 95.9023 100.333C95.9023 100.783 96.2323 101.113 96.5923 101.263L99.2323 102.433L96.5923 103.573C96.2623 103.723 95.9023 104.053 95.9023 104.503C95.9023 105.043 96.3523 105.523 96.8923 105.523C97.1623 105.523 97.3723 105.403 97.6423 105.223L99.8923 103.573L99.5923 106.273Z",
  fill: "#ED4300"
});

var _ref32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_411_287",
  x1: 82.9108,
  y1: 38.4358,
  x2: 83.9591,
  y2: 37.1865,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#EA4403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2632,
  stopColor: "#EA4A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4566,
  stopColor: "#EC5A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EE7203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7747,
  stopColor: "#F18402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8AE00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_411_287",
  x1: 83.8683,
  y1: 38.4385,
  x2: 86.1658,
  y2: 38.6395,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#EA4403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2356,
  stopColor: "#EA4A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3928,
  stopColor: "#EC5A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#EE7203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6535,
  stopColor: "#F18402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8604,
  stopColor: "#F9B301"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9959,
  stopColor: "#FFD500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD500"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_411_287"
}, /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 160,
  fill: "white"
})));

var SvgLaptopLocked = function SvgLaptopLocked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_287)"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 51,
    width: 40,
    height: 41
  }, _ref23), _ref24, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_411_287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 51,
    width: 40,
    height: 41
  }, _ref25), _ref26, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_411_287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 51,
    width: 40,
    height: 41
  }, _ref27), _ref28, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_411_287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 51,
    width: 40,
    height: 41
  }, _ref29), _ref30, _ref31), _ref32);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLaptopLocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/laptop-locked.4eb8a811.svg";
export { ForwardRef as ReactComponent };